import Storage from 'good-storage'
import Config from '../config/app.js'

export function getToken() {
    return Storage.session.get(Config.tokenKey)
}

export function setToken(token) {
    return Storage.session.set(Config.tokenKey, token)
}

export function removeToken() {
    return Storage.session.remove(Config.tokenKey)
}

export function isLogin() {
    return (getToken() || '').length > 5
}

export function hasPromission(code) {
    return true;
}

let cache = {};
export function cacheServerData(key, request) {
    var promise = new Promise((resolve, reject) => {
        var data = cache[key]
        if (data) resolve(data);
        else {
            request().then((d) => {
                cache[key] = d;
                data = d;
                resolve(data);
            }).catch(() => {
                reject()
            })
        }
    })
    return promise;
}